import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import React from 'react'
import style from './AcceptCompleteAppointmentModal.module.css'
import { Header } from 'components/header/Header'
import { AppButton, ButtonTheme } from 'components/app-button/AppButton'

type AcceptCompleteAppointmentModalProps = {
  title: string
  warningText: string
  handleClose: () => void
  handleSave: () => void
}

export const AcceptCompleteAppointmentModal = (
  props: AcceptCompleteAppointmentModalProps
): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className={style.parentContainer}>
      <Box className={style.newConversationContainer}>
        <Header label={props.title} />
        <Box>
          <Typography className={style.inputTitle}>{props.warningText}</Typography>
        </Box>
        <form>
          <Box display={'flex'} justifyContent={'center'} />
          <Box
            display={'flex'}
            justifyContent={'center'}
            width={'100%'}
            style={{ marginTop: '8%' }}
          >
            <Box mr={4}>
              <AppButton
                theme={ButtonTheme.NewSecondary}
                type={'button'}
                label={t('close')}
                handler={props.handleClose}
              />
            </Box>
            <AppButton
              theme={ButtonTheme.NewPrimary}
              type={'button'}
              label={t('send')}
              handler={props.handleSave}
            />
          </Box>
        </form>
      </Box>
    </div>
  )
}
